import styled from "styled-components";

export const Container = styled.div`
  box-sizing: border-box;
  padding: 5.2rem 3.2rem 1rem 3.2rem;
  & > div {
    margin-bottom: 2.7rem;
  }
`;

export const ContainerAgent = styled.div`
  box-sizing: border-box;
`;
